import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { TableContainer as DefaultTable } from 'components/DefaultTable/styles';
import { styledScroll } from 'styles/styledScroll';

import colors from 'themes/Main';

const { darkBlue, gray03, pink, success, danger, warning } = colors;

export const Table = styled(DefaultTable)`
  .table-responsive {
    ${styledScroll};
    padding-bottom: 128px;
  }

  thead tr th {
    svg {
      margin-left: 8px;
    }

    &:nth-child(2),
    &:nth-child(4) {
      cursor: pointer;
    }
  }

  tbody tr {
    cursor: default;

    &:hover {
      background-color: transparent;
    }

    td {
      div {
        margin-left: 4px;
      }

      &.not-allowed {
        cursor: not-allowed;
      }

      &:nth-child(2),
      &:nth-child(4),
      &:last-child {
        width: 24%;
      }

      &:nth-child(3) {
        min-width: 280px;
        max-width: 300px;
      }

      &:first-child {
        width: 1%;
        position: relative;

        &:hover div {
          display: block;
        }

        div {
          display: none;
          position: absolute;
          top: 40px;
          left: 10px;
        }
      }

      &.status-0 {
        color: ${gray03};
      }

      &.status-1,
      &.status-4 {
        color: ${pink};
      }

      &.status-2 {
        color: ${warning};
      }

      &.status-3 {
        color: ${success};
      }

      &.status-5 {
        color: ${danger};
      }

      &[class^='status-'] {
        font-weight: 700;
      }
    }
  }
`;

export const LinkAction = styled(Link)`
  color: ${darkBlue} !important;
  text-decoration: underline;
  font-size: 14px;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
    opacity: 0.6;
  }
`;

export const ButtonAction = styled.button`
  cursor: pointer;
  background-color: transparent;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  color: ${darkBlue};
  border: 0;
  outline: 0;

  &:hover {
    transition: opacity 300ms ease-in-out;
    opacity: 0.6;
  }

  &:disabled {
    cursor: not-allowed;
    text-decoration: none;
    font-style: italic;
    color: ${gray03};
  }
`;
